import { memo, useCallback } from 'react';
import { IconCheck } from '@tabler/icons-react';
import { LayoutPopupOption } from '../../ClipCustomizer/Layout/constants';
import { LayoutDisableReason } from '../../ClipCustomizer/constants';
import IconButton from '@/components/atoms/Button/IconButton';
import TooltipV2 from '@/components/TooltipV2';
import { classnames } from '@/libs/utils';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';

function ClipCustomizerMagicLayoutIconButton({
  optionDetails,
  trackingId,
  isActive,
  isDisabled = false,
  disabledReason,
  onClick
}: {
  optionDetails: LayoutPopupOption;
  trackingId: string;
  isActive: boolean;
  isDisabled?: boolean;
  disabledReason?: string;
  onClick: () => void;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
}) {
  const disabledClickHandler = useCallback(() => {
    if (disabledReason === LayoutDisableReason.UNMIGRATED_LIVE_EVENT_DOESNT_SUPPORT_SPEAKER_LAYOUTS) {
      EventBus.dispatch(CustomEvents.OpenEventMigrationPopup, { source: 'ClipCustomizerMagicLayout' });
    }
    return;
  }, [disabledReason]);

  return (
    <TooltipV2
      tooltipElement={
        <div className={classnames('group relative', isDisabled ? 'cursor-not-allowed' : 'cursor-pointer')}>
          <div
            className={classnames(
              'flex w-full items-center justify-between rounded-md px-2 py-1',
              isActive ? 'bg-slate-200' : 'bg-white',
              isDisabled ? 'opacity-30' : ''
            )}
            onClick={isDisabled ? disabledClickHandler : onClick}
          >
            <IconButton
              icon={optionDetails.icon}
              content={optionDetails.label}
              variation="none"
              trackingId={trackingId}
              buttonClassName="relative flex space-x-1 px-3 py-1 text-sm font-medium focus:!ring-black "
            />
            {isActive && <IconCheck className="mr-2 text-black" size={18} stroke={2.5} />}
          </div>
        </div>
      }
      tooltipContent={disabledReason || ''}
      tooltipId={`magic-layout-${trackingId}`}
      place="left"
      size="base"
      colorTheme="light"
      className="!px-3 !py-1.5 !text-sm"
      opacity={1}
      offset={24}
    />
  );
}

export default memo(ClipCustomizerMagicLayoutIconButton);
